import { render, staticRenderFns } from "./AppDepartmentHeroBlock.vue?vue&type=template&id=7184c7fc"
import script from "./AppDepartmentHeroBlock.vue?vue&type=script&lang=js"
export * from "./AppDepartmentHeroBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports